module.exports = __webpack_public_path__ + "img/autenticidad-5.7f0b873a.svg";